<div class="contact-history-list">
    <div *ngFor="let campaign of contactHistory.campaigns; let i=index;">
        <div *ngIf="campaign.name != ''" class="header-history">
            <div class="d-flex">
                <h4>
                    {{campaign.name}}
                </h4>

                <div class="restart-campaign ms-2" ngbTooltip="Restart Campaign" (click)="restartCampaign(campaign)">
                    <img src="./assets/images/restart-icon.png">
                </div>
                
                <div class="ms-2">
                    {{campaign.createdDate | date: 'medium'}}
                </div>
            </div>

            <div class="d-flex">
                <p-dropdown class="short"
                    [options]="!campaign.email ? ['SMS'] : !campaign.sms ? ['Email'] : ['Email', 'SMS']"
                    [(ngModel)]="selectedCampaigns[i]"
                />
            </div>
        </div>
        <div>
            <div *ngIf="selectedCampaigns[i] == 'Email'">
                <div class="cards-ctr" style="margin:0px!important; padding: 10px!important">
                    <div class="state-card" [ngClass]="campaign.email.sentReviewRequest == -1 ? 'disabled' : ''">
                        <div class="header opt1">
                            <span>SENT REVIEW REQUEST</span>
                        </div>

                        <div class="info">
                            {{campaign.email.sentReviewRequest != -1 ? (dateToString(campaign.email.sentReviewRequest)) : 'No info'}}
                        </div>
                    </div>

                    <div *ngFor="let reminder of campaign.email.sentReminders; let i=index">
                        <div class="state-card" [ngClass]="reminder == -1 ? 'disabled' : ''">
                            <div class="header opt1">
                                <span>SENT REMINDER {{i+1}}</span>
                            </div>

                            <div class="info">
                                {{reminder != -1 ? (dateToString(reminder)) : 'No info'}}
                            </div>
                        </div>
                    </div>

                    <div class="state-card"
                        *ngIf="campaign.email.openedRequest"
                        [class.disabled]="campaign.email.openedRequest == -1"
                    >
                        <div class="header opt2">
                            <span>OPENED REQUEST</span>
                        </div>

                        <div class="info">
                            {{campaign.email.openedRequest != -1 ? (dateToString(campaign.email.openedRequest)) : 'No info'}}
                        </div>
                    </div>

                    <div class="state-card"
                        [class.disabled]="campaign.email.openedLanding == -1"
                    >
                        <div class="header opt3">
                            <span>OPENED LANDING</span>
                        </div>

                        <div class="info">
                            {{campaign.email.openedLanding != -1 ? (dateToString(campaign.email.openedLanding)) : 'No info'}}
                        </div>
                    </div>

                    <div class="state-card"
                        *ngIf="campaign.email.sentimentCheck"
                        [class.disabled]="campaign.email.sentimentCheck == -1">
                        <div class="header opt4">
                            <span>
                                SENTIMENT CHECK

                                {{ campaign.email.sentimentCheck !== -1 && campaign.email.lastSentimentCheck !== -1
                                    ? ': '
                                    : ''
                                }}

                                {{ campaign.email.sentimentCheck !== -1 && campaign.email.lastSentimentCheckType === sentimentCheckEnum.Stars
                                    ? campaign.email.lastSentimentCheck
                                    : ''
                                }}

                                <img
                                    *ngIf="campaign.email.sentimentCheck !== -1 && campaign.email.lastSentimentCheck !== -1"
                                    src="assets/images/sentimentCheck/{{getSentimentCheckType(campaign.email.lastSentimentCheck, campaign.email.lastSentimentCheckType)}}.png"
                                    class="sentiment-check"
                                />
                            </span>
                        </div>

                        <div class="info">
                            {{campaign.email.sentimentCheck != -1
                                ? (dateToString(campaign.email.sentimentCheck))
                                : 'No info'
                            }}
                        </div>
                    </div>

                    <div class="state-card"
                        [class.disabled]="campaign.email.clickedOnReview == -1"
                    >
                        <div class="header opt4">
                            <span class="review-site">
                                CLICKED ON REVIEW{{ campaign.email.clickedOnReview !== -1
                                    ? ': '+campaign.email.lastReviewSite.toUpperCase()
                                    : ''
                                }}
                            </span>
                        </div>

                        <div class="info">
                            {{ campaign.email.clickedOnReview != -1
                                ? (dateToString(campaign.email.clickedOnReview))
                                : 'No info'
                            }}
                        </div>
                    </div>

                    <div class="state-card"
                        [class.disabled]="campaign.email.clickedOnFeedback == -1"
                    >
                        <div class="header opt4">
                            <span>CLICKED ON FEEDBACK</span>
                        </div>

                        <div class="info">
                            {{ campaign.email.clickedOnFeedback != -1
                                ? (dateToString(campaign.email.clickedOnFeedback))
                                : 'No info'
                            }}
                        </div>
                    </div>

                    <div class="state-card"
                        [class.disabled]="campaign.email.leftFeedback == -1"
                    >
                        <div class="header opt5">
                            <span>LEFT FEEDBACK</span>
                        </div>

                        <div class="info">
                            {{ campaign.email.leftFeedback != -1
                                ? dateToString(campaign.email.leftFeedback)
                                : 'No info'
                            }}
                        </div>
                    </div>

                    <div class="state-card" *ngIf="campaign.email.unsubscribed"
                        [class.disabled]="campaign.email.unsubscribed == -1"
                    >
                        <div class="header opt6">
                            <span>LEFT UNSUSCRIBED</span>
                        </div>

                        <div class="info">
                            {{campaign.email.unsubscribed != -1
                                ? dateToString(campaign.email.unsubscribed)
                                : 'No info'
                            }}
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="selectedCampaigns[i] == 'SMS'">
                <div class="cards-ctr" style="margin:0px!important; padding: 10px!important">
                    <div class="state-card"
                        [class.disabled]="campaign.sms.sentReviewRequest == -1"
                    >
                        <div class="header opt1">
                            <span>SENT REVIEW REQUEST</span>
                        </div>

                        <div class="info">
                            {{ campaign.sms.sentReviewRequest != -1
                                ? dateToString(campaign.sms.sentReviewRequest)
                                : 'No info'
                            }}
                        </div>
                    </div>

                    <div *ngFor="let reminder of campaign.sms.sentReminders; let i=index">
                        <div class="state-card" [class.disabled]="reminder == -1">
                            <div class="header opt1">
                                <span>SENT REMINDER {{i+1}}</span>
                            </div>

                            <div class="info">
                                {{ reminder != -1
                                    ? (dateToString(reminder))
                                    : 'No info'
                                }}
                            </div>
                        </div>
                    </div>

                    <div class="state-card"
                        [class.disabled]="campaign.sms.openedLanding == -1"
                    >
                        <div class="header opt3">
                            <span>OPENED LANDING</span>
                        </div>

                        <div class="info">
                            {{ campaign.sms.openedLanding != -1
                                ? (dateToString(campaign.sms.openedLanding))
                                : 'No info'
                            }}
                        </div>
                    </div>

                    <div class="state-card"
                        *ngIf="campaign.sms.sentimentCheck"
                        [class.disabled]="campaign.sms.sentimentCheck == -1"
                    >
                        <div class="header opt4">
                            <span>
                                SENTIMENT CHECK

                                {{ campaign.sms.sentimentCheck !== -1 && campaign.sms.lastSentimentCheck !== -1
                                    ? ': '
                                    : ''
                                }}

                                {{ campaign.sms.sentimentCheck !== -1 && campaign.sms.lastSentimentCheckType === sentimentCheckEnum.Stars
                                    ? campaign.sms.lastSentimentCheck
                                    : ''
                                }}

                                <img
                                    *ngIf="campaign.sms.sentimentCheck !== -1 && campaign.sms.lastSentimentCheck !== -1"
                                    src="assets/images/sentimentCheck/{{getSentimentCheckType(campaign.sms.lastSentimentCheck, campaign.sms.lastSentimentCheckType)}}.png"
                                    class="sentiment-check"
                                />
                            </span>
                        </div>

                        <div class="info">
                            {{ campaign.sms.sentimentCheck != -1
                                ? (dateToString(campaign.sms.sentimentCheck))
                                : 'No info'
                            }}
                        </div>
                    </div>

                    <div class="state-card"
                        [class.disabled]="campaign.sms.clickedOnReview == -1"
                    >
                        <div class="header opt4">
                            <span class="review-site">
                                CLICKED ON REVIEW{{ campaign.sms.clickedOnReview !== -1
                                    ? ': ' + campaign.sms.lastReviewSite.toUpperCase()
                                    : ''
                                }}
                            </span>
                        </div>

                        <div class="info">
                            {{ campaign.sms.clickedOnReview != -1
                                ? dateToString(campaign.sms.clickedOnReview)
                                : 'No info'
                            }}
                        </div>
                    </div>

                    <div class="state-card"
                        [class.disabled]="campaign.sms.clickedOnFeedback == -1"
                    >
                        <div class="header opt4">
                            <span>CLICKED ON FEEDBACK</span>
                        </div>

                        <div class="info">
                            {{ campaign.sms.clickedOnFeedback != -1
                                ? dateToString(campaign.sms.clickedOnFeedback)
                                : 'No info'
                            }}
                        </div>
                    </div>

                    <div class="state-card"
                        [class.disabled]="campaign.sms.leftFeedback == -1"
                    >
                        <div class="header opt5">
                            <span>LEFT FEEDBACK</span>
                        </div>

                        <div class="info">
                            {{ campaign.sms.leftFeedback != -1
                                ? dateToString(campaign.sms.leftFeedback)
                                : 'No info'
                            }}
                        </div>
                    </div>

                    <div class="state-card" *ngIf="campaign.sms.unsubscribed"
                        [class.disabled]="campaign.sms.unsubscribed == -1"
                    >
                        <div class="header opt6">
                            <span>LEFT UNSUSCRIBED</span>
                        </div>

                        <div class="info">
                            {{ campaign.sms.unsubscribed != -1
                                ? dateToString(campaign.sms.unsubscribed)
                                : 'No info'
                            }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="no-results" *ngIf="contactHistory.campaigns.length == 0">
        No results found
    </div>    
</div>
